var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13392 11.5613H26.8673C27.7131 11.5613 28.4277 11.0371 28.6464 10.2438C28.8652 9.46462 28.5298 8.64295 27.8152 8.23212L15.8423 1.29045C15.011 0.808783 13.9902 0.808783 13.1735 1.29045L1.18601 8.23212C0.45684 8.64295 0.136007 9.46462 0.354757 10.2438C0.573507 11.0371 1.28809 11.5613 2.13392 11.5613Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1667 20.7699H25.8021V14.749C25.8021 14.1682 25.3063 13.6865 24.7083 13.6865H18.875C18.2771 13.6865 17.7812 14.1682 17.7812 14.749V20.7699H11.2188V14.749C11.2188 14.1682 10.7229 13.6865 10.125 13.6865H4.29167C3.69375 13.6865 3.19792 14.1682 3.19792 14.749V20.7699H2.83333C1.43333 20.7699 0.28125 21.889 0.28125 23.249V26.0824C0.28125 26.6632 0.777083 27.1449 1.375 27.1449H27.625C28.2229 27.1449 28.7188 26.6632 28.7188 26.0824V23.249C28.7188 21.889 27.5667 20.7699 26.1667 20.7699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.a1368f4a5dbb7a123c072a4448db6079.svg";
export { ForwardRef as ReactComponent };